module.exports = __webpack_public_path__ + "img/green_button.cd87aaee.png";